import { Component, Input } from '@angular/core';

/**
 * Avisa que parte dos acessos do login ficou de fora pela restrição de IP do credor.
 *
 * O backend devolve essas contas no fim da lista do login, marcadas com bloqueadoPorIp e sem hash.
 * Sem o aviso, o credor simplesmente some da seleção e a pessoa não sabe o motivo.
 */
@Component({
  selector: 'app-acessos-barrados-ip',
  templateUrl: './acessos-barrados-ip.component.html',
  styleUrls: ['./acessos-barrados-ip.component.css']
})
export class AcessosBarradosIpComponent {
  credores: string[] = [];
  ip: string;

  @Input() set acessos(valor: any[]) {
    const lista = valor ?? [];
    this.ip = lista.find(x => x.ip)?.ip;
    // Mesmo credor em mais de uma conta aparece uma vez só.
    this.credores = [...new Set(lista.map(x => x.nomeCredor || x.descricao).filter(Boolean))] as string[];
  }
}
